import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface ExpressSetupContact {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  distributorId: string;
}

const useCreateExpressSetupContactQuery = () => {
  const { mutateAsync, isLoading, isError } = useMutation((contact: ExpressSetupContact) =>
    api.post(API_URL.EXPRESS_SETUP_CONTACTS, {
      username: contact?.username,
      password: contact?.password,
      first_name: contact?.firstName,
      last_name: contact?.lastName,
      email: contact?.email,
      phone: contact?.phone,
      distributor_id: contact?.distributorId,
    })
  );

  return {
    createExpressSetupContact: mutateAsync,
    isLoading,
    isError,
  };
};

export default useCreateExpressSetupContactQuery;
